import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav";
import PosterMosaic from "./components/PosterMosaic";
import Hero from "./components/Hero";
import IntroBar from "./components/IntroBar";
import SelectedTitles from "./components/SelectedTitles";
import AISection from "./components/AISection";
import Contact from "./components/Contact";
import ProductionInPoland from "./components/ProductionInPoland";

// Removes the obvious download / drag entry points from all media on the
// site. Scoped to <img> and <video> only.
const useMediaDownloadGuard = () => {
  useEffect(() => {
    const guard = (e) => {
      const t = e.target;
      if (!t || !t.tagName) return;
      if (t.tagName === "IMG" || t.tagName === "VIDEO") {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", guard);
    document.addEventListener("dragstart", guard);
    return () => {
      document.removeEventListener("contextmenu", guard);
      document.removeEventListener("dragstart", guard);
    };
  }, []);
};

// Scroll to the hash target after route changes so `/#titles` works from any
// page. Deferred to the next frame so the target element is mounted.
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const scroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    // Wait one frame so newly mounted section elements are present.
    const t = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(t);
  }, [pathname, hash]);
  return null;
};

const Home = () => {
  useMediaDownloadGuard();
  return (
    <div
      className="relative min-h-screen"
      style={{
        background: "#080808",
        color: "#F5F5F3",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "clip",
      }}
      data-testid="page-home"
    >
      <PosterMosaic />

      <div className="relative" style={{ zIndex: 10 }}>
        <Nav />
        <main>
          <Hero />
          <IntroBar />
          <SelectedTitles />
          <AISection />
          <Contact />
        </main>
      </div>
    </div>
  );
};

const PolandRoute = () => {
  useMediaDownloadGuard();
  return <ProductionInPoland />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/production-in-poland" element={<PolandRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
